export const videosData = [
    {
        author:'Core Team',
        time:'Wed, 29 Jul 2020 23:46:41 GMT',
        title:'We visualized the development process of the current version, what an exciting process. Come on, friends.',
        url:'https://www.youtube.com/embed/JVUlLwvzQIE'
    }
];
